import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, InvoiceService, ReportService, SessionInformationService, UtilityService } from 'app/core/core.module';
import { Order } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-sales-commission',
    templateUrl: './sales-commission.component.html',
    styleUrls: ['./sales-commission.component.scss'],
    standalone: false,
})
export class SalesCommissionComponent implements OnInit {
    orders: any[];
    filteredOrders: any[];
    salesReps: any[];
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        private route: ActivatedRoute,
        public auth: AuthService,
        private appInfo: AppInformationService,
        private reportService: ReportService,
        private utility: UtilityService,
        private modalService: BsModalService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        await this.getData();
        this.filter = {};
        this.filteredOrders = this.orders;
    }

    async getData() {
        this.salesReps = await this.uow.getSalesReps();
        const dealers = await this.uow.getDealers(true);
        let orders = null;
        orders = (await this.uow.getSalesOrdersForCommissions()) as Order[];
        orders.forEach((x) => {
            x.net = x.total - x.freight;
            const submittedDates = x.orderLines.filter((x) => !!x.submitted).map((x) => x.submitted.getTime());
            x.submitted = submittedDates.length > 0 ? new Date(Math.min(...submittedDates)) : null;
        });
        this.orders = orders;
    }

    search() {
        let data = this.orders;
        if (this.filter.salesRepId) {
            data = data.filter((x) => x.salesRepId == this.filter.salesRepId);
        }

        if (this.filter.submittedStart) {
            console.log(this.filter.submittedStart);
            data = data.filter((x) => x.submitted >= this.filter.submittedStart);
        }

        if (this.filter.submittedEnd) {
            data = data.filter((x) => x.submitted <= moment(this.filter.submittedEnd).endOf('day'));
        }
        this.filteredOrders = data;
    }

    clear() {
        this.filteredOrders = this.orders;
        this.filter = {};
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
}
